import React, { FunctionComponent } from 'react';

import Icon from '../../Icons';

import { Container, IconWrapper } from './styles';

interface Props {
  id: string;
  value: string;
  label: string;
  handleChange: any;
  validation: any;
  selected: string;
  iconPath: string;
}

const IconRadio: FunctionComponent<Props> = ({ id, value, label, handleChange, validation, selected, iconPath }) => {
  return (
    <Container className="mr54" key={value}>
      <input
        type="radio"
        value={value}
        name={id}
        id={value}
        checked={value === selected}
        onChange={handleChange}
        ref={validation}
      />
      <label htmlFor={value}>
        <IconWrapper className="flex falign-c justify-content-c icon-wrapper relative">
          <img src={iconPath} alt={value} />
          <span>{selected === value ? <Icon name="blue-tick" /> : null}</span>
        </IconWrapper>
        <p className="mt8 text-center">{label}</p>
      </label>
    </Container>
  );
};

export default IconRadio;
